import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Col, Row } from 'reactstrap';

import axios from 'axios';
import { setNewCancelToken, setViewTimespan } from '../../../../redux/actions/general';
import { cancelTokenSelector } from '../../../../redux/selectors/selectors';
import { LIVE_CAPTIONS_VIEW } from '../../../../constants/general';
import { Dashboard } from '../../../common';
import Widget from '../../Widget/Widget';
import { AccessLevel } from '../../../../constants/AccessLevels';
import UptimeUsageLiveCaptions from '../../../widgets/liveCaptions/UsagebyUptime/UptimeUsageLiveCaptions';
import { SourceLanguage, TargetLanguage } from '../../../widgets/liveCaptions/Languages/Languages';
import { TokenUsageByStreamName, UptimeUsageByStreamName } from '../../../widgets/liveCaptions/UsagebyStreamName/UsageByStreamName';
import Concurrency from '../../../widgets/liveCaptions/Concurrency/Concurrency';

function LiveCaptions({ location, history }) {
   const cancelToken = useSelector(cancelTokenSelector);
   const cancelTokenRef = useRef(cancelToken);
   cancelTokenRef.current = cancelToken;
   const dispatch = useDispatch();
   useEffect(() => {
      return () => {
         cancelTokenRef.current.cancel('Operation canceled by the user.');
         dispatch(setViewTimespan(LIVE_CAPTIONS_VIEW));
         dispatch(setNewCancelToken(axios.CancelToken.source()));
      };
   }, [dispatch]);

   return (
      <Dashboard location={location} history={history} view={LIVE_CAPTIONS_VIEW}>
         <Row className='animated fadeIn'>
            <Col xs='12' sm='12' md='12' lg='12' xl='12'>
               <Widget
                  type={UptimeUsageLiveCaptions}
                  requiredLevel={AccessLevel.FULL}
                  widgetAttributes={{ height: 300 }}
               />
            </Col>
         </Row>
         <Row className='animated fadeIn'>
            <Col xs='12' sm='12' md='12' lg='6' xl='6'>
               <Widget type={SourceLanguage} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
            </Col>
            <Col xs='12' sm='12' md='12' lg='6' xl='6'>
               <Widget type={TargetLanguage} requiredLevel={AccessLevel.FULL} widgetAttributes={{ height: 300 }} />
            </Col>
         </Row>
         <Row className='animated fadeIn'>
            <Col xs='12' sm='12' md='12' lg='6' xl='6'>
               <Widget
                  type={UptimeUsageByStreamName}
                  requiredLevel={AccessLevel.FULL}
                  widgetAttributes={{ height: 300 }}
               />
            </Col>
            <Col xs='12' sm='12' md='12' lg='6' xl='6'>
               <Widget
                  type={TokenUsageByStreamName}
                  requiredLevel={AccessLevel.ADMIN}
                  widgetAttributes={{ height: 300 }}
               />
            </Col>
         </Row>
         <Row className='animated fadeIn'>
            <Col xs='12' sm='12' md='12' lg='12' xl='12'>
               <Widget type={Concurrency} requiredLevel={AccessLevel.ADMIN} widgetAttributes={{ height: 300 }} />
            </Col>
         </Row>
      </Dashboard>
   );
}

export default LiveCaptions;
